






































































import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import logger from 'vuex/types/logger';
import { roleServe } from '@/api/installServer';
import RoleDeptChoice from '@/views/system/permission/role/unit/roleDeptChoice.vue';

@Component({
  components: { RoleDeptChoice },
})
export default class EditRole extends Vue {
  // @PropSync('flag', Number) editRoleFlag!: number; // 显示哪个页面
  @Prop(String) rowId!: string; // 传递给编辑页面,角色分配功能权限页面的表单数据对象
  editRoleFlag = 2;
  scrollbar = false;
  // 表单数据对象
  basicInfoData: object = {
    name: '',
    spaceId: '',
    spaceCode: '',
    dataScopeType: '',
    description: '',
    allDeptVisible: true,
    visibleDeptIdList: [],
  };

  // 数据权限类型 数据
  dataScopeType: Array<any> = [
    {
      value: 'all',
      label: '全部数据 ',
    },
    {
      value: 'currentSpace',
      label: '本公司数据',
    },
    {
      value: 'currentDeptAndSubDept',
      label: '本部门数据',
    },
    {
      value: 'custom',
      label: '自定义数据',
    },
  ];

  // 表单验证规则对象
  formRules: object = {
    name: [{ required: true, trigger: 'blur', message: '必填信息' }], // 角色名称
  };

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.querySelector('#main_box');
    // this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
    // console.log(dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight)
    if (dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight) {
      this.scrollbar = false;
    } else {
      this.scrollbar = true;
    }
  }

  created() {
    this.getAllData();
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 调接口，修改数据
   * @param1 暂无
   * @returns 暂无
   */
  getAllData(): void {
    // console.log('rowId', this.rowId)  // rowId 每一行对应的Id
    // 获取全部数据
    if (this.editRoleFlag === 2) {
      roleServe
        .getRoleLineData(this.rowId)
        .then((res: any) => {
          this.basicInfoData = res.data;
          // console.log('res', res)  // 每一行的数据
        })
        .catch((error: any) => {
          // this.$message({
          //   type: 'info',
          //   message: '网络错误，请检查网络',
          // });
          console.log(error);
        });
    }
  }
  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮返回角色管理界面
   * @param1 暂无
   * @returns 暂无
   */
  backRole(): void {
    this.$emit('close');
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击按钮保存 编辑角色 页面内容
   * @param1 暂无
   * @returns 暂无
   */
  saveEditRole(): void {
    (this.$refs.formRef as any).validate((valid: any) => {
      if (valid) {
        // 修改角色管理页面的信息
        if (this.editRoleFlag === 2) {
          roleServe
            .editRoleData({ ...this.basicInfoData })
            .then((res: any) => {
              if (res.code === '200') {
                this.$message.success('保存成功');
                // this.$router.go(0);
                this.backRole(); // 跳转到 index 页面
              }
            })
            .catch(() => {
              this.$message.error('保存失败,请稍后重试!');
            });
        }
      } else {
        return false;
      }
    });
  }
  /**
   * 更新可见部门的值
   * @param data
   */
  updateVisibleDeptIdList(data: any) {
    (this.basicInfoData as any).visibleDeptIdList = data;
  }
}
